<h2 class="vx-section-header text-uppercase mb-3 text-center h5">{{ 'MISC.RELATEDPROD' | translate }}</h2>
<div class="text-center" [ngClass]="carousel.length > 1?'':''">
  <div id="carouselRelated" class="carousel slide carousel-fade my-3" data-bs-ride="carousel">
    <div class="carousel-inner">
      <div *ngFor="let product of carousel; let i = index;let isFirst = first" [class.active]="isFirst"
        class="carousel-item p-3 rounded" [ngClass]="carousel.length > 1?'':''">
        <div class="row align-items-start d-flex justify-content-center">
          <div class="col-6 col-lg-3 my-2">
            <div class='card vx-product-card h-100 shadow-sm'>
              <h2 class='card-header d-block text-center h6 p-1 text-truncate'><a [routerLink]="product[0].link"
                  queryParamsHandling="merge" [queryParams]="{ product: product[0].title }">{{product[0].title}}</a>
              </h2>
              <div class='card-img-top text-center p-1'> <a [attr.aria-label]="product[0].title"
                  [routerLink]="product[0].link" queryParamsHandling="merge"
                  [queryParams]="{ product: product[0].title }"><img loading="lazy" [ngSrc]="product[0].imgsrc" [alt]="'VeEX ' + product[0].title"
                    class="img-fluid" width="200" height="200" /></a>
              </div>
              <div class="row subtitlespace h6 bluebackground g-0 card-header p-1">
                <div class="col-sm-12 my-auto">
                  <p class="m-0 p-0 small text-center" [innerHTML]="product[0].subtitle | translate"></p>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="product[1]" class="col-6 col-lg-3 my-2">
            <div class='card vx-product-card h-100 shadow-sm'>
              <h2 class='card-header d-block text-center h6 p-1 text-truncate'><a [routerLink]="product[1].link"
                  queryParamsHandling="merge" [queryParams]="{ product: product[1].title }">{{product[1].title}}</a>
              </h2>
              <div class='card-img-top text-center p-1'> <a [attr.aria-label]="product[1].title"
                  [routerLink]="product[1].link" queryParamsHandling="merge"
                  [queryParams]="{ product: product[1].title }"><img loading="lazy" [ngSrc]="product[1].imgsrc" [alt]="'VeEX ' + product[1].title"
                    class="img-fluid" width="200" height="200" /></a>
              </div>
              <div class="row subtitlespace h6 bluebackground g-0 card-header p-1">
                <div class="col-sm-12 my-auto">
                  <p class="m-0 p-0 small text-center" [innerHTML]="product[1].subtitle | translate"></p>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="product[2]" class="col-6 col-lg-3 my-2">
            <div class='card vx-product-card h-100 shadow-sm'>
              <h2 class='card-header d-block text-center h6 p-1 text-truncate'><a [routerLink]="product[2].link"
                  queryParamsHandling="merge" [queryParams]="{ product: product[2].title }">{{product[2].title}}</a>
              </h2>
              <div class='card-img-top text-center p-1'> <a [attr.aria-label]="product[2].title"
                  [routerLink]="product[2].link" queryParamsHandling="merge"
                  [queryParams]="{ product: product[2].title }"><img loading="lazy" [ngSrc]="product[2].imgsrc" [alt]="'VeEX ' + product[2].title"
                    class="img-fluid" width="200" height="200" /></a>
              </div>
              <div class="row subtitlespace h6 bluebackground g-0 card-header p-1">
                <div class="col-sm-12 my-auto">
                  <p class="m-0 p-0 small text-center" [innerHTML]="product[2].subtitle | translate"></p>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="product[3]" class="col-6 col-lg-3 my-2">
            <div class='card vx-product-card h-100 shadow-sm'>
              <h2 class='card-header d-block text-center h6 p-1 text-truncate'><a [routerLink]="product[3].link"
                  queryParamsHandling="merge" [queryParams]="{ product: product[3].title }">{{product[3].title}}</a>
              </h2>
              <div class='card-img-top text-center p-1'> <a [attr.aria-label]="product[3].title"
                  [routerLink]="product[3].link" queryParamsHandling="merge"
                  [queryParams]="{ product: product[3].title }"><img loading="lazy" [ngSrc]="product[3].imgsrc" [alt]="'VeEX ' + product[3].title"
                    class="img-fluid" width="200" height="200" /></a>
              </div>
              <div class="row subtitlespace h6 bluebackground g-0 card-header p-1">
                <div class="col-sm-12 my-auto">
                  <p class="m-0 p-0 small text-center" [innerHTML]="product[3].subtitle | translate"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="carousel.length > 1">
      <a class="carousel-control-prev" data-bs-target="#carouselRelated" type="button" data-bs-slide="prev">
        <div class="carousel-arrow">
          &lt; </div> <span class="visually-hidden">{{ 'BUTTON.PREV' | translate }}</span>
      </a>
      <a class="carousel-control-next" data-bs-target="#carouselRelated" type="button" data-bs-slide="next">
        <div class="carousel-arrow">
          &gt;
        </div>
        <span class="visually-hidden">{{ 'BUTTON.NEXT' | translate }}</span>
      </a>
    </ng-container>
  </div>
</div>
